<!-- eslint-disable vue/no-v-html -->
<template>
  <ys-list-item :interactive="true" data-test="search-result-item">
    <div v-if="$slots.overline" slot="overline" data-test="overline-slot">
      <slot name="overline"></slot>
    </div>

    <div slot="leading" class="result-icon">
      <slot name="icon">
        <search-result-icon :result-type="iconGlyph" data-test="result-icon" />
      </slot>
    </div>

    <ys-text slot="label" type="title5" data-test="result-title">
      <slot name="label">
        {{ name }}
      </slot>
    </ys-text>

    <div
      v-if="$slots.metadata"
      slot="underline"
      data-test="metadata-slot"
      class="result-metadata"
    >
      <slot name="metadata"></slot>
    </div>

    <div
      v-if="resultImage"
      slot="trailing"
      class="image-container"
      data-test="result-image"
    >
      <img
        class="image"
        draggable="false"
        :src="resultImage"
        :alt="`Image of ${name}`"
        data-test="result-image"
      />
    </div>
  </ys-list-item>
</template>

<script setup lang="ts">
///// imports /////
import { computed } from 'vue'
import '@onxmaps/yellowstone-ui/ys-text'
import SearchResultIcon from '@/components/search/search-result-icon.vue'

import { getResultImage } from '@/lib/search/search-utils'

///// props/emits /////
interface ResultItemTemplateProps {
  /** Name to display for the search result.  Optional since the #name slot can also be used for more complicated displays */
  name?: string
  /** Name of glyph icon to display for the search result */
  iconGlyph?: string
  /** URL of the image to display for the search result */
  imageUrl?: string
}
const {
  name = '',
  iconGlyph,
  imageUrl,
} = defineProps<ResultItemTemplateProps>()

const resultImage = computed(() => {
  return imageUrl ? getResultImage(imageUrl) : undefined
})
</script>

<style lang="scss" scoped>
@use '@/styles/system/_fonts.scss';

.result-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ys-color-text-primary);
  font-family: fonts.$onxGlyphIcon;
  font-size: 24px;
  min-width: 24px;
}

.result-metadata {
  color: var(--ys-color-text-secondary);
}

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-container {
  width: 48px;
  height: 48px;
  border-radius: var(--ys-radius-100);
  overflow: hidden;
}
</style>
